// Diccionario ÚNICO de etiquetas legibles del sistema.
// Enum interno → texto que ve el usuario. La traducción ocurre AL RENDERIZAR,
// no se toca el valor que se persiste en la DB. Así las evaluaciones históricas
// también salen bien.
//
// Regla: si un valor no está en este diccionario, `formatLabel` limpia el crudo
// (reemplaza guiones bajos, baja MAYÚSCULAS_ASÍ) — pero NUNCA lo devuelve tal cual.

// ============================================================================
// 5 escenarios del motor (etiquetas exactas — coordinadas con el usuario)
// ============================================================================
export const SCENARIO_LABEL = {
  PUEDE_INICIAR: 'Inicio habilitado',
  APTO_PARA_EJERCICIO_MODERADO: 'Inicio prudente',
  APTO_PARA_PROGRESAR_CON_CONTROL: 'Continúa con seguimiento',
  APTO_REQUERIDO: 'Consulta médica recomendada',
  DERIVACION_INMEDIATA: 'Requiere evaluación médica',
  // Aliases legacy — mismos labels canónicos.
  APTO_RECOMENDABLE: 'Inicio prudente',
  APTO_PARA_PROGRESAR: 'Continúa con seguimiento',
};

// ============================================================================
// Nivel de actividad física (incluye TODOS los sinónimos históricos)
// ============================================================================
export const ACTIVITY_LEVEL_LABEL = {
  sedentario: 'Sedentario',
  // Wizard actual guarda "insuficientemente_activa" antes del map a "irregular"
  insuficientemente_activa: 'Insuficientemente activo/a',
  insuficientemente_activo: 'Insuficientemente activo/a',
  irregular: 'Insuficientemente activo/a',
  // Wizard puede guardar "activa_regular"; motor lo lee como "activo_regular"
  activa_regular: 'Activo/a regular',
  activo_regular: 'Activo/a regular',
  // Legacy default en inglés en RegisterPage
  sedentary: 'Sedentario',
  // Valores históricos observados en DB — semánticamente ambiguos
  // (no se puede saber si eran "irregular" o "activo_regular").
  moderado: 'Sin clasificar (registro anterior)',
  moderate: 'Sin clasificar (registro anterior)',
};

// ============================================================================
// Sexo (los valores ya se guardan en español legible — se mantiene por consistencia)
// ============================================================================
export const SEX_LABEL = {
  Masculino: 'Masculino',
  Femenino: 'Femenino',
  'No binario': 'No binario',
  'Prefiero no responder': 'Prefiero no responder',
};

// ============================================================================
// Tipo de diabetes
// ============================================================================
export const DIABETES_TYPE_LABEL = {
  tipo_1: 'Tipo 1',
  tipo_2: 'Tipo 2',
  tipo1: 'Tipo 1',
  tipo2: 'Tipo 2',
  1: 'Tipo 1',
  2: 'Tipo 2',
  '1': 'Tipo 1',
  '2': 'Tipo 2',
};

// ============================================================================
// Resolvedor genérico. Si no encuentra el enum en el diccionario,
// limpia el valor crudo (nunca devuelve MAYÚSCULAS_ASÍ ni snake_case al UI).
// ============================================================================
export function formatLabel(dictionary, value, fallback = '—') {
  if (value === null || value === undefined || value === '') return fallback;
  const found = dictionary[value];
  if (found) return found;
  const raw = String(value);
  const cleaned = raw.replace(/_/g, ' ').toLowerCase();
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

export const getScenarioLabel = (estado) =>
  formatLabel(SCENARIO_LABEL, estado, 'Sin resultado');
export const getActivityLabel = (level) => formatLabel(ACTIVITY_LEVEL_LABEL, level, '—');
export const getSexLabel = (sex) => formatLabel(SEX_LABEL, sex, '—');
export const getDiabetesTypeLabel = (t) => formatLabel(DIABETES_TYPE_LABEL, t, '');
